/**
* Toggle layout field
*/

const sel:any = document.querySelector(".js-notice");
const radios: any = document.querySelectorAll('[name="notice"]');
const layoutBlock = document.querySelector(".form__block--layout");

const orderNotice = () => {
  if(!layoutBlock) return;
  
  radios.forEach((radio: any) => {
    if(sel.checked) {
      layoutBlock.classList.add("hide")
    }
    else {
      layoutBlock.classList.remove("hide");
    }

    radio.addEventListener("change", () => {
      if(sel.checked) {
        layoutBlock.classList.add("hide")
      }
      else {
        layoutBlock.classList.remove("hide");
      }
    })
  })

}

export default orderNotice
